import { api } from "./../../config/api";
import { appendToFormData } from "./../../helpers/form";

const basePath = "splash";

/**
 * Get all
 *
 * @param {Object} options
 * @param {integer} [options.page]
 * @param {integer} [options.limit]
 * @param {string} [options.search]
 * @param {string} [options.orderBy]
 *
 * @returns {Promise<T>}
 */
export const getAll = (options) => {
	const options_default = {};

	// Merge config
	options = Object.assign({}, options_default, options);

	let params    = [];
	let params_qs = "";

	if( options.page )
	{
		params.push(`page=${options.page}`);
	}

	if( options.limit )
	{
		params.push(`limit=${options.limit}`);
	}

	if( options.search )
	{
		params.push(`search=${options.search}`);
	}

	if( options.orderBy )
	{
		params.push(`orderBy=${options.orderBy}`);
	}

	if( params.length )
	{
		params_qs = `?${params.join("&")}`;
	}

	return api.get(`${basePath}${params_qs}`).then((response) => {
		return Promise.resolve(response);
	})
	.catch((data) => {
		return Promise.reject(data);
	});
};

/**
 * Show
 *
 * @param {Object} options
 * @param {integer} options.id
 *
 * @returns {Promise<T>}
 */
export const show = (options) => {
	return api.get(`${basePath}/${options.id}`).then((response) => {
		return Promise.resolve(response);
	})
	.catch((data) => {
		return Promise.reject(data);
	});
};

/**
 * Create
 *
 * @param {Object} options
 * @param {object} options.file
 * @param {string} options.name
 * @param {string} [options.url]
 * @param {boolean} [options.is_active]
 *
 * @returns {Promise<T>}
 */
export const create = (options) => {
	const formData = new FormData();

	for( let key in options )
	{
		if( options.hasOwnProperty(key) )
		{
			appendToFormData(formData, key, options[key]);
		}
	}

	return api.post(basePath, formData);
};

/**
 * Edit
 *
 * @param {Object} options
 * @param {number} options.id
 * @param {object} [options.file]
 * @param {string} [options.name]
 * @param {string} [options.url]
 * @param {boolean} [options.is_active]
 *
 * @returns {Promise<T>}
 */
export const edit = (options) => {
	const formData = new FormData();

	for( let key in options )
	{
		if( options.hasOwnProperty(key) )
		{
			appendToFormData(formData, key, options[key]);
		}
	}

	return api.post(`${basePath}/${options.id}`, formData);
};

/**
 * Delete
 *
 * @param {Object} options
 * @param {integer} options.id
 *
 * @returns {Promise<T>}
 */
export const destroy = (options) => {
	return api.delete(`${basePath}/${options.id}`).then((response) => {
		return Promise.resolve(response);
	})
	.catch((data) => {
		return Promise.reject(data);
	});
};
